import { PartnerRemoteDataSource } from "@/infrastructure/datasources/implementations/remote/PartnerRemoteDataSource";
import { ProfessionalRemoteDataSource } from "@/infrastructure/datasources/implementations/remote/ProfessionalRemoteDataSource";
import { UserRemoteDataSource } from "@/infrastructure/datasources/implementations/remote/UserRemoteDataSource";
import { QuestionaireRemoteDataSource } from "@/infrastructure/datasources/implementations/remote/QuestionaireRemoteDataSource";
import adapters from "./adapters";

export default {
    partnerDataSource: new PartnerRemoteDataSource(adapters.network),
    userSubscriptionHistoryDataSource: new UserRemoteDataSource(adapters.network),
    questionaireDataSource: new QuestionaireRemoteDataSource(adapters.network),
    professionalDataSource: new ProfessionalRemoteDataSource(adapters.network),
}